import React from 'react'

import Header from './header'
import Body from './body'
import Footer from './footer'

function Todo() {
  return (
    <div>
      <Header />
      <Body />
      <Footer />
    </div>
  )
}

export default Todo
